import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank');
      e.target.value = '';
    }
  };

  return (
    <section className="w-full bg-background-50 py-8 md:py-10">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-xl p-5 md:p-7">
          <h3 className="text-sm font-semibold text-foreground-700 mb-4 font-heading">
            <i className="ri-arrow-down-s-line mr-1.5"></i>
            Kategorie auswählen und direkt zum Produkt navigieren
          </h3>
          <div className="relative">
            <select
              onChange={handleChange}
              defaultValue=""
              className="w-full appearance-none bg-background-50 border border-background-200/70 rounded-lg px-4 py-3 pr-10 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all cursor-pointer"
            >
              <option value="" disabled>-- Kategorie wählen --</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <span className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-400 text-base"></i>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}